import styled from '@emotion/styled'
import { AntdConfigProvider, Steps } from '@vivaldis/antd-ui'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { WPS_FORM_STEPS } from '../../constants/wpsFormSteps'
import { useStep } from '../../providers/StepProvider'

interface Props {
  // when a custom PDF is uploaded there are no steps: all of them are shown as inactive
  disabled: boolean
}

export const StepsProgressHeader = ({ disabled }: Props) => {
  const [t] = useTranslation('web_ui')
  const { step } = useStep()

  const items = useMemo(
    () =>
      WPS_FORM_STEPS.map((_, index) => ({
        title: t('work_post_sheet_form.steps.step_title', { step: index + 1 }),
        disabled
      })),
    [disabled, t]
  )

  return (
    <Base>
      <AntdConfigProvider
        theme={{
          components: {
            Steps: {
              descriptionMaxWidth: 110
            }
          }
        }}
      >
        <Steps
          // -1: no step is active or finished
          current={disabled ? -1 : step}
          orientation="horizontal"
          responsive={false}
          type="dot"
          size="small"
          items={items}
        />
      </AntdConfigProvider>
    </Base>
  )
}

const Base = styled('div')`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  padding-top: 20px;
  padding-bottom: 12px;
  margin: -16px -16px 16px -16px;
  background-color: ${props => props.theme.white};
`
